const parseToFloat = value =>
  parseFloat(value.toString().replace(/[^0-9.]/g, ""));

const defaultSortProperty = { name: "date", isDesc: true };

export default {
  props: {
    displayDeclinedTransactions: {
      type: Boolean,
      required: true,
      default: false
    },
    transactionStatuses: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      filterModel: {
        orderNumber: null,
        amount: null,
        firstName: null,
        lastName: null,
        email: null,
        transactionStatus: [],
        dataRange: null
      },
      headers: [],
      tableOptions: {
        sortBy: [defaultSortProperty.name],
        sortDesc: [defaultSortProperty.isDesc]
      }
    };
  },
  computed: {
    headerValues() {
      return this.headers.map(header => header.value);
    }
  },
  methods: {
    customSort(items, index, isDesc) {
      let Index = defaultSortProperty.name;
      let IsDesc = false;
      if (!index.length) {
        IsDesc = defaultSortProperty.isDesc;
      } else {
        Index = index[0];
        IsDesc = !!isDesc.length ? isDesc[0] : false;
      }
      items.sort((a, b) => {
        switch (Index) {
          case "date":
            return this.sortDates(a, b, IsDesc);
          case "amount":
            return this.sortAmount(a, b, IsDesc);
          default:
            return this.genericSort(a[Index], b[Index], IsDesc);
        }
      });
      return items;
    },
    sortAmount(a, b, isDesc) {
      const aAmount = parseToFloat(a.amount);
      const bAmount = parseToFloat(b.amount);
      return this.genericSort(aAmount, bAmount, isDesc);
    },
    sortDates(a, b, isDesc) {
      const aDate = new Date(a.transactionDate);
      const bDate = new Date(b.transactionDate);
      return this.genericSort(aDate, bDate, isDesc);
    },
    genericSort(a, b, isDesc) {
      const descending = isDesc ? -1 : 1;
      return (a < b ? -1 : 1) * descending;
    },
    filterByDate(value, search, item) {
      if (this.filterModel.dataRange == null) return true;

      let itemDate = new Date(item.date);

      if (
        this.filterModel.dataRange.to != null &&
        this.filterModel.dataRange.to < itemDate
      )
        return false;

      if (
        this.filterModel.dataRange.from != null &&
        this.filterModel.dataRange.from > itemDate
      )
        return false;

      return true;
    },
    filterByStatus(value, search, item) {
      if (
        this.filterModel.transactionStatus == null ||
        !this.filterModel.transactionStatus.length
      )
        return true;

      return this.filterModel.transactionStatus.includes(
        item.transactionStatus
      );
    },
    textFilter(filterModelProperty) {
      return (value, search, item) => {
        const model = this.filterModel[filterModelProperty];
        if (!model || model == "") return true;
        if (!item[filterModelProperty]) return false;

        return item[filterModelProperty]
          .toString()
          .toUpperCase()
          .includes(model.toUpperCase());
      };
    },
    setupFilters(header) {
      const model = header.value;
      this.$set(this.filterModel, model, null);
      header["filter"] = this.textFilter(model);
      return header;
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const uSearch = search.toUpperCase();
      return this.headerValues.some(header =>
        this.genericFilter(item[header], uSearch)
      );
    },
    genericFilter(value, search) {
      if (!value) return false;
      return value
        .toString()
        .toUpperCase()
        .includes(search);
    },
    filterDeclinedTransactions(status) {
      if (this.displayDeclinedTransactions) return true;
      return (
        !!this.transactionStatuses[status] &&
        !!this.transactionStatuses[status].display
      );
    }
  }
};
